import { Button } from "@circleco/compass/components/Button";
import type { IconName } from "@circleco/compass/components/Icon";

interface CircleAIDockNavRowProps {
  icon: IconName;
  isActive?: boolean;
  label: string;
  onClick: () => void;
}

export const CircleAIDockNavRow = ({
  icon,
  isActive,
  label,
  onClick,
}: CircleAIDockNavRowProps) => (
  <Button
    variant={isActive ? "secondary" : "ghost"}
    startIcon={icon}
    fullWidth
    onClick={onClick}
    {...(isActive !== undefined && { "aria-pressed": isActive })}
  >
    <span className="truncate">{label}</span>
  </Button>
);
